import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import {
  fetchHistoricCommunication,
  fetchedHistoricCommunication,
  exportHistoricCommunication,
  exportedHistoricCommunication,
  fetchHistoricCommunicationSenders,
  fetchedHistoricCommunicationSenders,
} from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type historicCommunicationListActionPayload = ReturnType<typeof fetchHistoricCommunication>;
type ExportHistoricCommunicationPayload = ReturnType<typeof exportHistoricCommunication>;

function* HistoricCommunicationSaga({ payload }: historicCommunicationListActionPayload) {
  const { getHistoricCommunications } = getAPI();
  const response: YieldOf<typeof getHistoricCommunications> = yield call(getHistoricCommunications, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedHistoricCommunication(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedHistoricCommunication(undefined, error));
  }
}

function* exportExportHistoricCommunicationSaga({ payload, meta }: ExportHistoricCommunicationPayload) {
  const { exportHistoricCommunication } = getAPI();
  const response: YieldOf<typeof exportHistoricCommunication> = yield call(
    exportHistoricCommunication,
    payload,
    meta.language
  );
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(exportedHistoricCommunication(data));
  } else {
    const error = problem || 'unknown';
    yield put(exportedHistoricCommunication(undefined, error));
  }
}

function* historicCommunicationSendersSaga() {
  const { getCommunicationSenders } = getAPI();
  const response: YieldOf<typeof getCommunicationSenders> = yield call(getCommunicationSenders);
  const { data, ok, problem, status } = response;

  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedHistoricCommunicationSenders(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedHistoricCommunicationSenders(undefined, error));
  }
}

export default function* HistoricSaga() {
  yield takeLatest(fetchHistoricCommunication.type, HistoricCommunicationSaga);
  yield takeLatest(exportHistoricCommunication.type, exportExportHistoricCommunicationSaga);
  yield takeLatest(fetchHistoricCommunicationSenders.type, historicCommunicationSendersSaga);
}
